import SettingsDialog from './SettingsDialog';

export default SettingsDialog;
